import React from 'react';
import moment from 'moment-timezone';

import {
  listOperators,
  numberOperators,
  segmentOperators,
  stringOperators,
  cohortOperators,
  types,
  likeOperators,
  dateOperators,
} from '../../constants/filter';
import DateSelector from '../shared/DateSelector';
import SegmentSelector from '../../containers/filter/SegmentSelector';
import CohortSelector from '../../containers/filter/CohortSelector';
import { DATE_DAILY_FORMAT, FULL_DATE_FORMAT } from '../../constants/date';
import { sortNumbers, unique } from '../../utils/collection';
import JexlSelector from './JexlSelector';
import BoolSelector from './BoolSelector';
import MultipleValuesSelector from './MultipleValuesSelector';

const getValueSelectorFor = (
  onSelectOperator,
  onValueChange,
  operator,
  value,
  meta,
  zoneId,
  operatorStyle,
  operatorValueStyle
) => {
  const values = Array.isArray(meta.values)
    ? unique(meta.values.filter((e) => e !== null))
    : meta.values;

  switch (meta.type) {
    case types.BOOL:
      return (
        <BoolSelector
          onValueChange={(...args) => {
            onSelectOperator('=', false);
            onValueChange(...args);
          }}
          value={value}
        />
      );

    case types.NUMBER:
      return (
        <MultipleValuesSelector
          onSelectOperator={onSelectOperator}
          onValueChange={onValueChange}
          operator={operator}
          operatorStyle={operatorStyle}
          operatorValueStyle={operatorValueStyle}
          operators={numberOperators}
          value={value}
          values={sortNumbers(values)}
          // Т.к. для фильтра для события ve_level для его значений из метаинфы приходят строки.
          // Разобраться с тем, почему бэк-энд шлет строчные значения вместо числовых.
          type={meta.type}
        />
      );

    case types.STRING:
      return (
        <MultipleValuesSelector
          onSelectOperator={onSelectOperator}
          onValueChange={onValueChange}
          operator={operator}
          operatorStyle={operatorStyle}
          operatorValueStyle={operatorValueStyle}
          operators={stringOperators}
          value={value}
          values={likeOperators.includes(operator) ? [] : values}
          type={meta.type}
        />
      );

    case types.LIST:
      return (
        <MultipleValuesSelector
          onSelectOperator={onSelectOperator}
          onValueChange={onValueChange}
          operator={operator}
          operatorStyle={operatorStyle}
          operatorValueStyle={operatorValueStyle}
          operators={listOperators}
          value={value}
          values={values}
          type={meta.elementsType}
        />
      );

    case types.DATE:
      return (
        <DateSelector
          onSelectOperator={onSelectOperator}
          onValueChange={onValueChange}
          operators={dateOperators}
          operator={operator}
          operatorStyle={operatorStyle}
          value={value}
          zoneId={zoneId}
        />
      );

    case types.SEGMENT:
      return (
        <SegmentSelector
          onSelectOperator={onSelectOperator}
          onValueChange={onValueChange}
          operator={operator}
          operatorStyle={operatorStyle}
          operatorValueStyle={operatorValueStyle}
          operators={segmentOperators}
          value={value}
          type={types.STRING}
          customizable={false}
        />
      );

    case types.JEXL:
      return <JexlSelector onValueChange={onValueChange} value={value} />;

    case types.COHORT:
      return (
        <CohortSelector
          onSelectOperator={onSelectOperator}
          onValueChange={(valuesParam) => {
            const formattedValue = valuesParam.map((v) =>
              moment.tz(v, DATE_DAILY_FORMAT, zoneId).format(FULL_DATE_FORMAT)
            );
            onValueChange(formattedValue);
          }}
          operator={operator}
          operatorStyle={operatorStyle}
          operatorValueStyle={operatorValueStyle}
          operators={cohortOperators}
          value={(value || []).map((v) =>
            moment.tz(v, FULL_DATE_FORMAT, zoneId).format(DATE_DAILY_FORMAT)
          )}
          field={meta.field}
          type={types.STRING}
        />
      );

    default:
      return <span />;
  }
};

const ValueSelectorContainer = ({
  onSelectOperator,
  onValueChange,
  render,
  operator,
  value,
  meta,
  zoneId,
  style = {},
  operatorStyle,
  operatorValueStyle,
}) => (
  <div style={{ marginLeft: 10, ...style }}>
    {render
      ? getValueSelectorFor(
          onSelectOperator,
          onValueChange,
          operator,
          value,
          meta,
          zoneId,
          operatorStyle,
          operatorValueStyle
        )
      : null}
  </div>
);

export default ValueSelectorContainer;
